import { BAOCustomElement } from '@bao/custom-element'
import { Cart } from '@bao/cart'
import { sectionRenderer } from '@bao/section-rendering'

export class ProductForm extends BAOCustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  constructor () {
    super()

    this._loading = false
    this.sections = this.inPushCart
      ? sectionRenderer.pushCartSections
      : this.onCartPage
        ? sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (event) {
    event.preventDefault()
    await this.addToCart()
  }

  async addToCart () {
    return Cart.addItemFromForm(this.form, {
      sections: this.mappedSections,
    })
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  get inPushCart () {
    return document.body.dataset.pageType !== 'cart'
  }

  get onCartPage () {
    return document.body.dataset.pageType === 'cart'
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }
}

customElements.define('product-form', ProductForm)
